
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesReturnMasterGrid extends _Ext.GridBase<SalesReturnMasterRow, any> {
        protected getColumnsKey() { return 'Sales.SalesReturnMaster'; }
        protected getDialogType() { return SalesReturnMasterDialog; }
        protected getIdProperty() { return SalesReturnMasterRow.idProperty; }
        protected getInsertPermission() { return SalesReturnMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesReturnMasterRow.localTextPrefix; }
        protected getService() { return SalesReturnMasterService.baseUrl; }
        private autoSize;
        constructor(container: JQuery,options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row); 
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(20);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[20].AutoPosting;

            this.editItem(<SalesReturnMasterRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                ExchRate: userDefinition.exchangerate,
                VoucherTypeId: 20,
                TransDate: now.toDateString(),
                AutoPosting: autoposting

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getButtons(): Serenity.ToolButton[] {
            var btn = super.getButtons();

            btn.push({
                title: 'Import Approval In Returns',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    if (!this.onViewSubmit()) {
                        return;
                    }
                    let transids;
                    SalesReturnMasterService.PostedTransIdList({}, response => { transids = response.Entities }, { async: false });
                    var _transids = transids.map(x => x.RefTransId);
                    var dialog = new Common.VoucherPostingDialog();
                    dialog.transids = _transids;
                    dialog.vouchertypeid = 14;

                    dialog.element.height(500);
                    dialog.element.width(500);
                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            var partyid = parseInt(dialog.form.PartyId.value);
                            if (dialog.vouchernos.length > 0)
                                SalesReturnMasterService.APIImportPurchaseReturns({ Entities: dialog.vouchernos, PartyId: partyid }, response => { this.refresh() }, { async: false });
                        }
                    });

                }
            });
            return btn;
        }

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}